import {FETCH_REFERRAL_ID,EDIT_REFERRAL_ID,FETCH_REFERRAL_ID_SUCCESS,FETCH_REFERRAL_ID_FAILED} from "../store/types"
import {backend} from "../config/configureBackend";
import { onValue,push,set } from "../config/supabaseDatabaseCompat";



export const fetchusedreferral = ()=>(dispatch)=>{
    const {
        usedreferralRef
    } = backend;


    dispatch ({
        type:FETCH_REFERRAL_ID,
        payload:null
    })
    onValue (usedreferralRef,snapshot=>{
        if (snapshot.val()) {
            const data = snapshot.val();
            const arr = Object.keys(data).map(i => {
              data[i].id = i
              return data[i]
            });
            dispatch({
              type: FETCH_REFERRAL_ID_SUCCESS,
              payload: arr.reverse()
            });
          } else {
            dispatch({
              type: FETCH_REFERRAL_ID_FAILED,
              payload: "No SOS available."
            });
          }
        // if(snapshot.val()){
        //     const data = snapshot.val();
        //     const arr = Object.keys(data).map(i=>{
        //         data[i].id = i;
        //         return data[i]
        //     });
        //     dispatch({
        //         type:FETCH_REFERRAL_ID_SUCCESS,
        //         payload:arr.reverse()
        //     });
        // }
        // else {
        //     dispatch({
        //         type:FETCH_REFERRAL_ID_FAILED,
        //         payload:"No referral id used"
        //     })
        // }
    })



}

export const editreferral = (users,method)=>(dispatch)=>{
    const {
        usedreferralRef,
    } = backend;

    dispatch({
        type:EDIT_REFERRAL_ID,
        payload:{method,users}
    });
    if(method ==='Add'){
        push(usedreferralRef,users)
        
    }
}